(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcb-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pcb-tabs')) {
    customElements.define(
      'pcb-tabs',
      class PcbTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index, false));
            tab.addEventListener('keydown', (event) => {
              let next = null;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (next === null) return;
              event.preventDefault();
              this.select(next, true);
            });
          });
          // Theme editor: open the tab whose block is selected.
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.tabs.indexOf(event.target);
            if (index > -1) this.select(index, false);
          });
        }

        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
          if (focus) this.tabs[index].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcb-split-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pcb-rail')) {
    customElements.define(
      'pcb-rail',
      class PcbRail extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.pcb-rail__track');
          this.buttons = Array.from(this.querySelectorAll('.pcb-rail__btn'));
          if (!this.track || !this.buttons.length) return;
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
              const item = this.track.querySelector('.pcb-rail__item');
              const step = item ? item.getBoundingClientRect().width + 12 : this.track.clientWidth;
              const perView = Math.max(1, Math.floor(this.track.clientWidth / step));
              this.track.scrollBy({ left: Number(button.dataset.dir) * step * perView, behavior: 'smooth' });
            });
          });
          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.buttons[0].disabled = this.track.scrollLeft <= 2;
          this.buttons[1].disabled = this.track.scrollLeft >= max;
          this.classList.toggle('pcb-rail--static', max <= 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
